export default "__VITE_ASSET__DhxhrCDa__"